<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CMConfigSetting">
      
        <!-- <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.device_id" clearable></el-input></div>
            <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
          </div>
        </div> -->
        <el-button type="primary" class="mb20 mt20" @click="openAdd">添加</el-button>
        <div class="contList" v-loading="tableLoading">
          <el-row :gutter="20">
            <el-col :span="8" v-for="(item,index) in configList" :key="index">
              <div class="item flex">
                <div class="img">
                  <img :src="item.Qrcode" alt="" :id="'item'+index">
                  <div class="item_btn"><el-button v-print="'#item'+index">打印</el-button></div>
                </div>
                <div class="itemCont">
                  <div class="name ellipsis">名称：{{item.audit_name}}</div>
                  <div class="people ellipsis">审批人：{{item.user_name}}</div>
                  <div class="phone ellipsis">手机号码：{{item.phone_no}}</div>
                  <div class="cont_btn">
                    <el-button type="text" @click="openStatus(index)">删除</el-button>
                    <el-button type="text" @click="openEdit(index)">修改<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--添加配置-->
      <el-dialog title="添加" :visible.sync="addConfigDio" width="700px">
        <div class="contDio">
          <div class="stepDiv">
            <el-steps :active="addform.stepActive" finish-status="success">
              <el-step title="添加基本信息"></el-step>
              <el-step title="添加设备ID"></el-step>
            </el-steps>
          </div>
          <div v-if="addform.stepActive == 0" key="1">
          <el-form ref="form" :rules="rules" :model="addform" label-width="90px">
            <el-form-item label="预约名称:" prop="yyName">
              <el-input v-model="addform.yyName" key="yyName"></el-input>
            </el-form-item>
            <el-form-item label="预约网址:" prop="website">
              <el-input v-model="addform.website" key="website"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <el-checkbox v-model="addform.isApprover">审批人:</el-checkbox>
              </span>
              <template v-if="addform.isApprover">
              <el-cascader
                class="db mb20"
                :options="deparList"
                v-model="addform.depart_id"
                change-on-select
                :props="selectProps2" 
                @change="getUserYy(addform.depart_id[addform.depart_id.length-1])">
              </el-cascader>
              <el-select v-model="addform.user_id" placeholder="请选择审批人" class="db">
                <el-option
                  v-for="item in userYyList"
                  :key="item.user_id"
                  :label="item.user_name"
                  :value="item.user_id">
                </el-option>
              </el-select>
              </template>
            </el-form-item>
          </el-form>
          </div>
          <div v-else key="2">
          <el-form ref="form7" :model="addform2" label-width="90px">
            <el-form-item label="查找方式:">
              <el-select v-model="addform2.mode" placeholder="请选择查找方式" class="db">
                <el-option label="按空间查找" value="1"></el-option>
                <el-option label="按类型查找" value="2"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="addform2.mode=='1'">
            <el-form-item label="所属空间:">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="addform2.space_id"
                change-on-select
                :props="selectProps"
                @change="getSpaceDeviceYy(addform2.space_id[addform2.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            </template>
            <template v-if="addform2.mode=='2'">
            <el-form-item label="类型:">
              <div class="flex">
              <el-select v-model="addform2.type" placeholder="请选择设备类型" @change="typeChangeYy">
                <el-option
                  v-for="item in deviceType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <template v-if="addform2.typeCode=='ACCESS'">
              <div class="ml20">门禁级别：</div>
              <el-select v-model="addform2.typeSpecif" placeholder="请选择门禁级别" @change="getDeviceListByType(addform2.typeSpecif)">
                <el-option label="A" value="A"></el-option>
                <el-option label="B" value="B"></el-option>
                <el-option label="C" value="C"></el-option>
              </el-select>
              </template>
              </div>
            </el-form-item>
            </template>
          </el-form>
          <!--穿梭框-->
          <div class="tranferEdit flex">
            <div class="tranItem">
              <div class="tranTit">
                <el-checkbox :indeterminate="leftinfo.isIndeterminate" v-model="leftinfo.checkAll" @change="leftAllChange">未选择设备</el-checkbox>
                <div class="number"><template v-if="leftinfo.checkNum!=0">{{leftinfo.checkNum}}/</template>{{leftinfo.total}}</div>
              </div>
              <div class="search">
                <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="leftinfo.keyword"></el-input>
              </div>
              <div class="tranList">
                <template v-if="leftinfo.deviceData!=''">
                <el-checkbox-group v-model="leftinfo.ischeck" @change="leftChange">
                  <el-checkbox v-for="(item,index) in leftinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                </template>
                <div class="noData" v-else>暂无数据...</div>
              </div>
            </div>
            <div class="btnDiv">
              <div>
                <el-button icon="el-icon-arrow-left" v-if="rightinfo.ischeck==''">to left</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" v-else @click="toLeft">to left</el-button>
              </div>
              <div>
                <el-button v-if="leftinfo.ischeck==''">to right<i class="el-icon-arrow-right"></i></el-button>
                <el-button type="primary" v-else @click="toRight">to right<i class="el-icon-arrow-right"></i></el-button>
              </div>
            </div>
            <div class="tranItem">
              <div class="tranTit">
                <el-checkbox :indeterminate="rightinfo.isIndeterminate" v-model="rightinfo.checkAll" @change="rightAllChange">已选择设备</el-checkbox>
                <div class="number"><template v-if="rightinfo.checkNum!=0">{{rightinfo.checkNum}}/</template>{{rightinfo.total}}</div>
              </div>
              <div class="search">
                <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="rightinfo.keyword"></el-input>
              </div>
              <div class="tranList">
                <template v-if="rightinfo.deviceData!=''">
                <el-checkbox-group v-model="rightinfo.ischeck" @change="rightChange">
                  <el-checkbox v-for="(item,index) in rightinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                </template>
                <div class="noData" v-else>暂无数据...</div>
              </div>
            </div>
          </div>

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div v-if="addform.stepActive == 0" key="3">
          <el-button @click="addConfigDio = false">取消</el-button>
          <el-button @click="nextStep('form')">下一步</el-button>
          </div>
          <div v-else key="4">
          <el-button @click="addform.stepActive = 0">上一步</el-button>
          <el-button type="primary" @click="submitConfig()">确定</el-button>
          </div>
        </span>
      </el-dialog>
      <!--修改配置-->
      <el-dialog title="修改" :visible.sync="editConfigDio" width="700px">
        <div class="contDio">
          <el-tabs v-model="editform.tabActive">
            <el-tab-pane label="基本信息" name="1">
              <el-form ref="form2" :rules="rules" :model="editform" label-width="90px" class="mt20">
                <el-form-item label="预约名称:" prop="yyName">
                  <el-input v-model="editform.yyName" key="yyName"></el-input>
                </el-form-item>
                <el-form-item label="预约网址:" prop="website">
                  <el-input v-model="editform.website" key="website"></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <el-checkbox v-model="editform.isApprover">审批人:</el-checkbox>
                  </span>
                  <template v-if="editform.isApprover">
                  <el-cascader
                    class="db mb20"
                    :options="deparList"
                    v-model="editform.depart_id"
                    change-on-select
                    :props="selectProps2" 
                    @change="getUserYy(editform.depart_id[editform.depart_id.length-1])">
                  </el-cascader>
                  <el-select v-model="editform.user_id" placeholder="请选择审批人" class="db">
                    <el-option
                      v-for="item in userYyList"
                      :key="item.user_id"
                      :label="item.user_name"
                      :value="item.user_id">
                    </el-option>
                  </el-select>
                  </template>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="设备ID" name="2">
              <el-form ref="form3" :model="editform" label-width="90px" class="mt20">
                <el-form-item label="查找方式:">
                  <el-select v-model="editform.mode" placeholder="请选择查找方式" class="db">
                    <el-option label="按空间查找" value="1"></el-option>
                    <el-option label="按类型查找" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <template v-if="editform.mode=='1'">
                <el-form-item label="所属空间:">
                  <el-cascader
                    class="db"
                    :options="spaceList"
                    v-model="editform.space_id"
                    change-on-select
                    :props="selectProps"
                    @change="getSpaceDeviceYy(editform.space_id[editform.space_id.length-1])">
                  </el-cascader>
                </el-form-item>
                </template>
                <template v-if="editform.mode=='2'">
                <el-form-item label="类型:">
                  <div class="flex">
                  <el-select v-model="editform.type" placeholder="请选择设备类型" @change="typeChangeYy2()">
                    <el-option
                      v-for="item in deviceType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <template v-if="editform.typeCode=='ACCESS'">
                  <div class="ml20">门禁级别：</div>
                  <el-select v-model="editform.typeSpecif" placeholder="请选择门禁级别" @change="getDeviceListByType2(editform.typeSpecif)">
                    <el-option label="A" value="A"></el-option>
                    <el-option label="B" value="B"></el-option>
                    <el-option label="C" value="C"></el-option>
                  </el-select>
                  </template>
                  </div>
                </el-form-item>
                </template>
              </el-form>
              <!--穿梭框-->
              <div class="tranferEdit flex">
                <div class="tranItem">
                  <div class="tranTit">
                    <el-checkbox :indeterminate="leftinfo.isIndeterminate" v-model="leftinfo.checkAll" @change="leftAllChange">未选择设备</el-checkbox>
                    <div class="number"><template v-if="leftinfo.checkNum!=0">{{leftinfo.checkNum}}/</template>{{leftinfo.total}}</div>
                  </div>
                  <div class="search">
                    <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="leftinfo.keyword"></el-input>
                  </div>
                  <div class="tranList">
                    <template v-if="leftinfo.deviceData!=''">
                    <el-checkbox-group v-model="leftinfo.ischeck" @change="leftChange">
                      <el-checkbox v-for="(item,index) in leftinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                    </el-checkbox-group>
                    </template>
                    <div class="noData" v-else>暂无数据...</div>
                  </div>
                </div>
                <div class="btnDiv">
                  <div>
                    <el-button icon="el-icon-arrow-left" v-if="rightinfo.ischeck==''">to left</el-button>
                    <el-button type="primary" icon="el-icon-arrow-left" v-else @click="toLeft">to left</el-button>
                  </div>
                  <div>
                    <el-button v-if="leftinfo.ischeck==''">to right<i class="el-icon-arrow-right"></i></el-button>
                    <el-button type="primary" v-else @click="toRight">to right<i class="el-icon-arrow-right"></i></el-button>
                  </div>
                </div>
                <div class="tranItem">
                  <div class="tranTit">
                    <el-checkbox :indeterminate="rightinfo.isIndeterminate" v-model="rightinfo.checkAll" @change="rightAllChange">已选择设备</el-checkbox>
                    <div class="number"><template v-if="rightinfo.checkNum!=0">{{rightinfo.checkNum}}/</template>{{rightinfo.total}}</div>
                  </div>
                  <div class="search">
                    <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="rightinfo.keyword"></el-input>
                  </div>
                  <div class="tranList">
                    <template v-if="rightinfo.deviceData!=''">
                    <el-checkbox-group v-model="rightinfo.ischeck" @change="rightChange">
                      <el-checkbox v-for="(item,index) in rightinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                    </el-checkbox-group>
                    </template>
                    <div class="noData" v-else>暂无数据...</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editConfig('form3')">确定</el-button>
          <el-button @click="editConfigDio = false">取消</el-button>
        </span>
      </el-dialog>
      <!--预览二维码-->
      <!-- <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
        <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
        <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
      </el-dialog> -->

      <!--删除配置-->
      <el-dialog title="" :visible.sync="statusDio" class="statusDio">
        <div class="statusCont">
          <div>是否删除该配置？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delConfig">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { unmanApi,eSiteApi,sceneApi, bussinessApi,userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CMConfigSetting',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          device_id:'',
        },

        configList:[],//配置列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        addConfigDio:false,//添加弹窗
        addform:{
          stepActive:0,//步骤
          yyName:'',//预约名称
          website:'',//预约网址
          isApprover:false,//是否有审批人
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
          depart_id:[],
          user_id:'',//用户id
        },
        approverList:[],//审批人列表
        deparList:[],//部门树形
        userYyList:[],//审批人下拉
        rules:{
          yyName:[
            { required: true, message: '请输入预约名称', trigger: 'blur' },
          ],
          website:[
            { required: true, message: '请输入预约网址', trigger: 'blur' },
          ],
        },
        addform2:{
          mode:'1',//查找方式
          space_id:[],//空间id
          device_id:[],//选中设备
          type:'',//设备类型
          typeCode:'',
          typeSpecif:'A',//门禁级别
        },
        selectProps2:{
          label: 'name',
          value: 'id',
          children: 'children'
        },
        //穿梭框配置
        transProps:{
          key:'device_no_id',
          label:'device_name',
        },
        deviceType:[],
        deviceList5:[],
        deviceList4:[],
        deparList:[],//部门树形
        userYyList:[],//审批人下拉

        editConfigDio:false,//修改弹窗
        editform:{
          id:'',
          yyName:'',//预约名称
          website:'',//预约网址
          isApprover:false,//是否有审批人
          device_name:'',//设备名称
          device_id:[],//设备id
          space_id:[],//空间id
          type:'',//设备类型
          depart_id:[],
          user_id:'',//用户id
          tabActive:'1',//tab默认选中
          mode:'1',//查找方式
          typeCode:'',
          typeSpecif:'A',//门禁级别
        },
        
        rules2:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
          user_id:[
            { required: true, message: '请选择审批人', trigger: 'blur' },
          ],
        },
        spaceList:[],//空间列表
        deviceList:[],//设备列表
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children'
        },
        
        leftinfo:{
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        },
        rightinfo:{
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        },
        // previewDio:false,//预览二维码
        // dioImageUrl:'',//二维码地址

        statusDio:false,
        del_id:'',
      };
    },
    mounted(){

    },
    created: async function () {
      this.getWarehouse()
    },
    methods: {
      //筛选穿梭框
      screenList(){
        let that = this;
        for(var i in this.deviceList5){
          if(that.leftinfo.keyword!=''){
            if(that.deviceList5[i].device_name.indexOf(that.leftinfo.keyword) != -1 || that.deviceList5[i].device_no_id.indexOf(that.leftinfo.keyword) != -1){
              that.leftinfo.deviceData.push(that.deviceList5[i])
            }
          }else{
            that.leftinfo.deviceData = that.deviceList5
          }
        }
      },
      screenList2(){
        let that = this;
        for(var i in this.deviceList4){
          if(that.rightinfo.keyword!=''){
            if(that.deviceList4[i].device_name.indexOf(that.rightinfo.keyword) != -1 || that.deviceList4[i].device_no_id.indexOf(that.rightinfo.keyword) != -1){
              that.rightinfo.deviceData.push(that.deviceList4[i])
            }
          }else{
            that.rightinfo.deviceData = that.deviceList4
          }
        }
      },
      //穿梭框左边迁移右边
      toRight(){
        let that = this
        var arr = this.leftinfo.ischeck
        var arr2 = this.leftinfo.deviceData
        for(var i in arr){
          for(var ii in arr2){
            if(arr[i] == arr2[ii].device_no_id){
              that.rightinfo.deviceData.push(arr2[ii])
              arr2.splice(ii,1)
            }
          }
        }
        for(var i in arr){
          for(var y in that.deviceList5){
            if(arr[i] == that.deviceList5[y].device_no_id){
              that.deviceList5.splice(y,1)
            }
          }
        }
        let obj = {}
        let arr3 = that.rightinfo.deviceData.reduce((cur,next) =>{
          obj[next.device_no_id] ? "" : obj[next.device_no_id] = true && cur.push(next);
          return cur;
        },[])
        this.rightinfo.deviceData = arr3
        this.leftinfo.deviceData = arr2
        this.rightinfo.total = this.rightinfo.deviceData.length
        this.leftinfo.ischeck = []
        this.leftinfo.checkNum = 0
        this.leftinfo.total = this.leftinfo.deviceData.length
        this.leftinfo.isIndeterminate = false;
        this.leftinfo.checkAll = false
      },
      //穿梭框右边迁移左边
      toLeft(){
        let that = this
        var arr = this.rightinfo.ischeck
        var arr2 = this.rightinfo.deviceData
        for(var i in arr){
          for(var ii in arr2){
            if(arr[i] == arr2[ii].device_no_id){
              that.leftinfo.deviceData.push(arr2[ii])
              arr2.splice(ii,1)
            }
          }
        }
        for(var i in arr){
          for(var y in that.deviceList4){
            if(arr[i] == that.deviceList4[y].device_no_id){
              that.deviceList4.splice(y,1)
            }
          }
        }
        let obj = {}
        let arr3 = that.leftinfo.deviceData.reduce((cur,next) =>{
          obj[next.device_no_id] ? "" : obj[next.device_no_id] = true && cur.push(next);
          return cur;
        },[])
        this.leftinfo.deviceData = arr3
        this.rightinfo.deviceData = arr2
        this.leftinfo.total = this.leftinfo.deviceData.length
        this.rightinfo.ischeck = []
        this.rightinfo.checkNum = 0
        this.rightinfo.total = this.rightinfo.deviceData.length
        this.rightinfo.isIndeterminate = false;
        this.rightinfo.checkAll = false
      },
      //穿梭框左边全选
      leftAllChange(val){
        let idList = []
        for(var i in this.leftinfo.deviceData){
          idList.push(this.leftinfo.deviceData[i].device_no_id)
        }
        this.leftinfo.ischeck = val ? idList : [];
        this.leftinfo.isIndeterminate = false;
        this.leftinfo.checkNum = this.leftinfo.ischeck.length
      },
      //穿梭框左边单选
      leftChange(value){
        let checkedCount = value.length;
        this.leftinfo.checkAll = checkedCount === this.leftinfo.deviceData.length;
        this.leftinfo.isIndeterminate = checkedCount > 0 && checkedCount < this.leftinfo.deviceData.length;
        this.leftinfo.checkNum = this.leftinfo.ischeck.length
      },
      //穿梭框右边全选
      rightAllChange(val){
        let idList = []
        for(var i in this.rightinfo.deviceData){
          idList.push(this.rightinfo.deviceData[i].device_no_id)
        }
        this.rightinfo.ischeck = val ? idList : [];
        this.rightinfo.isIndeterminate = false;
        this.rightinfo.checkNum = this.rightinfo.ischeck.length
      },
      //穿梭框右边单选
      rightChange(value){
        let checkedCount = value.length;
        this.rightinfo.checkAll = checkedCount === this.rightinfo.deviceData.length;
        this.rightinfo.isIndeterminate = checkedCount > 0 && checkedCount < this.rightinfo.deviceData.length;
        this.rightinfo.checkNum = this.rightinfo.ischeck.length
      },
      //打开删除弹窗
      openStatus(index){
        this.del_id = this.configList[index].id
        this.statusDio = true;
      },
      //删除授权用户
      async delConfig(){
        let that = this;
        let data = {
          'id': that.del_id,//授权用户id
        }
        let res = await bussinessApi.delYuyueConfig(data)
        if (res.meta.code === 200) {
          that.getWarehouse(1)
          that.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //查看二维码
      // previewImg(img){
      //   this.dioImageUrl = img
      //   this.previewDio = true
      // },
      //修改配置
      editConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig(that.editform.id)
          } else {
            return false;
          }
        });
      },
      //打开修改配置
      openEdit(index){
        let that = this
        this.spaceList=[]
        this.deviceList=[]
        this.editform.id = this.configList[index].id

        this.leftinfo={
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        }
        this.rightinfo={
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        }
        this.deviceList5=[];
        this.deviceList4=[];
        this.deparList=[];
        this.userYyList=[];
        this.getSpaceList()
        this.getdeviceType()
        this.getDepartmentList()
        this.getAuditorInfo(index)
        this.editConfigDio = true;
      },
      //获取配置信息
      async getAuditorInfo(index){
        let that = this
        const data = {
          'id':that.configList[index].id
        }
        let res = await bussinessApi.getAuditorInfo(data)
        if (res.meta.code === 200) {
          that.editform.yyName = res.data.audit_name
          that.editform.website = res.data.qrcode_url
          that.editform.user_id = res.data.user_id
          // for(var i in res.data.device_no_id){
          //   that.editform.device_id.push(res.data.device_no_id[i].device_no_id)
          // }
          // that.editform.device_id = res.data.device_no_id
          that.deviceList4 = res.data.device_no_id
          that.screenList2()
          that.rightinfo.total = res.data.device_no_id.length
          if(res.data.user_id != ''){
            that.editform.isApprover = true
            that.getDepartmentInfo(res.data.department_id)
          }
        } else {
          showToast(res.meta.message)
        }
      },
      //通过部门id获取详情
      async getDepartmentInfo(depart_id){
        let that = this
        const data = {
          'id':depart_id
        }
        let res = await userApi.getDepartmentInfo(data)
        if (res.meta.code === 200) {
          for(let i in res.data.parent){
            that.editform.depart_id.push(res.data.parent[i].id)
          }
          that.getUserYy(that.editform.depart_id[that.editform.depart_id.length-1])
        } else {
          showToast(res.meta.message)
        }
      },
      //获取空间父id
      async getSpaceParentSpace(index){
        let that = this
        const data = {
          'space_id':that.configList[index].space_id
        }
        let res = await unmanApi.getSpaceParentSpace(data)
        if (res.meta.code === 200) {
          that.editform.space_id = res.data.space_str.split(',')
        } else {
          showToast(res.meta.message)
        }
      },
      //添加配置
      addConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig()
          } else {
            return false;
          }
        });
      },
      //提交配置
      async submitConfig(id){
        let that = this
        var device_id =[]
        for(var i in that.rightinfo.deviceData){
          device_id.push(that.rightinfo.deviceData[i].device_no_id)
        }
        if(id){
          var dataObj = {
            'id': id,
            'audit_name': that.editform.yyName,
            'qrcode_url': that.editform.website,
            'user_id':that.editform.user_id,
            'device_no_id':device_id,
          }
          var res = await bussinessApi.updateAppintmentAuditor(dataObj)
        }else{
          var dataObj = {
            'audit_name':that.addform.yyName,//预约名称
            'qrcode_url':that.addform.website,//预约地址
            // 'device_no_id':that.addform2.device_id,//设备id组
            'device_no_id':device_id,
          }
          if(this.addform.isApprover==true){
            dataObj.user_id=that.addform.user_id
          }
          var res = await bussinessApi.configYuyue(dataObj)
        }
        
        if (res.meta.code === 200) {
          that.leftinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:''
          }
          that.rightinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:''
          }
          if(!id){
            that.addform={
              stepActive:0,//步骤
              yyName:'',//预约名称
              website:'',//预约网址
              isApprover:false,//是否有审批人
              device_name:'',//设备名称
              device_id:'',//设备id
              space_id:[],//空间id
              type:'',//设备类型
              depart_id:[],
              user_id:'',//用户id
            }
            that.deviceType=[]
            that.deviceList5=[]
            that.deparList=[]
            that.userYyList=[]
            that.addConfigDio = false
            that.getWarehouse(1)
            showToast('配置成功！')
          }else{
            that.editConfigDio = false
            that.getWarehouse()
            showToast('修改成功！')
          }
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openAdd(){
        this.leftinfo={
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        }
        this.rightinfo={
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        }
        this.deviceList5=[];
        this.deviceList4=[]
        this.spaceList=[]
        this.deviceList=[]
        this.getSpaceList();
        this.deparList=[];
        this.userYyList=[];
        this.getDepartmentList();
        this.addConfigDio = true;
      },
      //预约下一步
      nextStep(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.addform.isApprover == true){
              if(that.addform.user_id==''){
                showToast('请选择审批人')
              }else{
                that.addform.stepActive = 1
                that.getdeviceType()
              }
            }else{
              that.addform.stepActive = 1
              that.getdeviceType()
            }
          } else { return false;}
        });
      },
      //穿梭框数据列渲染
      renderFunc(h, option) {
        return h('span',option.device_no_id+'-'+option.device_name)
      },
      //穿梭框自定义搜索逻辑
      filterMethod(query, item) {
        return item.device_no_id.indexOf(query) > -1 ||item.device_name.indexOf(query) > -1;
      },
      //切换类型（预约）
      typeChangeYy(){
        var that = this
        for(var i in that.deviceType){
          if(that.addform2.type == that.deviceType[i].id){
            that.addform2.typeCode=that.deviceType[i].code
          }
        }
        if(that.addform2.typeCode=='ACCESS'){
          that.getDeviceListByType(that.addform2.typeSpecif)
        }else{
          that.getDeviceListByType()
        }
      },
      //切换类型（预约）
      typeChangeYy2(){
        var that = this
        for(var i in that.deviceType){
          if(that.editform.type == that.deviceType[i].id){
            that.editform.typeCode=that.deviceType[i].code
          }
        }
        if(that.editform.typeCode=='ACCESS'){
          that.getDeviceListByType2(that.editform.typeSpecif)
        }else{
          that.getDeviceListByType2()
        }
      },
      //通过类型id获取预约的设备列表
      async getDeviceListByType2(level){
        let that = this;
        var dataObj = {
          'id': that.editform.type,
        }
        if(level){
          dataObj.level_type=that.editform.typeSpecif
        }
        let res = await bussinessApi.getDeviceListByType(dataObj)
        if(res.meta.code == 200){
          that.editform.device_id =[]
          that.deviceList5 = res.data.list
          that.leftinfo.total = res.data.list.length
          that.screenList()
        }else{
          showToast(res.meta.message)
        }
      },
      //通过类型id获取预约的设备列表
      async getDeviceListByType(level){
        let that = this;
        var dataObj = {
          'id': that.addform2.type,
        }
        if(level){
          dataObj.level_type=that.addform2.typeSpecif
        }
        let res = await bussinessApi.getDeviceListByType(dataObj)
        if(res.meta.code == 200){
          that.addform2.device_id =[]
          that.deviceList5 = res.data.list
          that.screenList()
        }else{
          showToast(res.meta.message)
        }
      },
      // 获取设备类型列表
      async getdeviceType() {
        let that = this
        const res = await bussinessApi.getDeviceTypeList()
        if (res.meta.code === 200) {
          that.deviceType = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      //获取空间列表
      async getSpaceList(){
        let that = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          that.processScene(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        let that = this
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
            for (let i in area) {
              let street = area[i].children
              for (let j in street) {
                let company = street[j]
                that.spaceList.push(company)
              }
            }
          }
        }

      },
      //同步设备类型
      getDeviType2(type){
        let that = this;
        for(let i in this.deviceList){
          if(type == 2){
            if(that.deviceList[i].device_no_id == this.editform.device_id){
              that.editform.type = that.deviceList[i].device_type
              that.editform.device_name = that.deviceList[i].device_name
            }
          }else{
            if(that.deviceList[i].device_no_id == this.addform.device_id){
              that.addform.type = that.deviceList[i].device_type
              that.addform.device_name = that.deviceList[i].device_name
            }
          }
          
        }
      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceYy(space_id,type){
        let that = this;
        const data = {
          'space_id': space_id,
        }
        const res = await bussinessApi.getSpaceDeviceYy(data)
        if(res.meta.code == 200){
          that.addform.device_id =''
          that.addform.type =''
          if(type == 2){
            const obj = {
              'device_name':that.editform.device_name,
              'device_no_id':that.editform.device_id,
              'device_type':that.editform.type,
            }
            res.data.splice(0,0,obj)
          }
          that.deviceList5 = res.data
          that.leftinfo.total = res.data.length
          that.screenList()
        }else{
          showToast(res.meta.message)
        }
      },
      //通过部门获取审批人
      async getUserYy(depart_id){
        let that = this
        const data = {
          'perPage':99999,
          'department_id':depart_id
        }
        const res = await userApi.getUserList(data)
        if (res.meta.code === 200) {
          that.userYyList = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取部门列表
      async getDepartmentList() {
        let that = this
        const res = await userApi.getDepartmentList()
        if (res.meta.code === 200) {
          that.deparList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //获取配置设置列表
      async getWarehouse(curr,limits){
        let that = this;
        this.tableLoading = true
        const data = {
          'page':curr ? curr : that.curr,//当前页
          'perPage': limits ? limits : that.page,//每页条数
          // 'location': that.keyword.device_address,//设备所在地址
          // 'device_id': that.keyword.device_id,//设备id
        }
        let res = await bussinessApi.auditorLiist(data)
        if(res.meta.code == 200){
          that.configList = res.data.list
          that.total = parseInt(res.data.total)
          that.tableLoading = false
        }else{
          that.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        this.getWarehouse(val)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      "leftinfo.keyword":function(){
        this.leftinfo.deviceData=[]
        this.screenList()
      },
      "rightinfo.keyword":function(){
        this.rightinfo.deviceData=[]
        this.screenList2()
      },
      
    }
  }
</script>

<style lang="scss">
@keyframes toggleShow {
  0%{
    top:150px;
  }
  100%{
    top: 0;
  }
}
.CMConfigSetting{
  .ellipsis{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .tranferEdit{
    align-items: center;
    .tranItem{
      width: 255px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      max-height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      .search{
        margin: 15px;
      }
      .tranTit{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        box-sizing: border-box;
        background: #ebeef5;
        align-items: center;
      }
      .tranList{
        height: 194px;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        .noData{
          text-align: center;
          padding: 20px;
        }
        .el-checkbox{
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
          display: flex;
          align-items: center;
          .el-checkbox__label{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    .btnDiv{
      padding: 0 30px;
      .el-button{
        margin: 5px 0;
      }
    }
  }
  .el-transfer-panel{
    width: 255px;
  }
  .flex{
    display: flex;
  }
  .contList{
    .item{
      border: 1px solid #ddd;
      display: flex;
      min-height: 150px;
      margin-bottom: 20px;
      align-content: center;
      .itemCont{
        flex-grow: 1;
        padding: 20px;
        line-height: 20px;
        .cont_btn{
          text-align: right;
        }
      }
      .img{
        flex-shrink: 0;
        width: 150px;
        height: 150px;
        text-align: center;
        position: relative;
        overflow: hidden;
        img{ width:100%;}
        .item_btn{
          position: absolute;
          left: 0;
          // top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255,255,255,.5);
          z-index: 10;
          display: none;
          align-items: center;
          justify-content: center;
          
        }
        &:hover .item_btn{
          display: flex;
          top: 0;
          animation: toggleShow 0.5s linear;
        }
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  // .contDio{
  //   .el-select{ display:block;}
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CMakeAppointment/CMConfigSetting.vue